import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fs-md-15 fs-lg-16",
  role: "alert"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12 mb-20" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "col-12 mb-40" }
const _hoisted_22 = {
  key: 0,
  class: "col-12 mb-20"
}
const _hoisted_23 = { class: "repeater-form" }
const _hoisted_24 = ["id"]
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = ["onChange"]
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = ["onUpdate:modelValue", "onInput"]
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = { class: "col-lg-1 col-md-1 d-flex align-items-end" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.user.stock == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[11] || (_cache[11] = [
            _createTextVNode(" Votre stock est désactivé ! Vous avez pouvez pas ajouter desproduits ", -1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            }, null, -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        style: _normalizeStyle([
          _ctx.user.stock == 0
            ? 'pointer-events: none; opacity: 0.6;'
            : 'opacity: 1;',
        ])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image du produit ", -1)),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.imagepreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.imagepreview,
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/NoImage.png'),
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_8)),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  ref: "updateImgInput",
                  type: "file",
                  accept: "image/*",
                  class: "d-none",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                }, " Choisir la photo "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                }, " Annuler ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du produit", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Sensung Smart Watch",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prod_name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.prod_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Référence Produit ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Sensung Smart Watch",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ref_prod) = $event)),
                disabled: _ctx.variants == true,
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkRef(_ctx.ref_prod)))
              }, null, 40, _hoisted_13), [
                [_vModelText, _ctx.ref_prod]
              ]),
              (_ctx.refcheck)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, "Référence du produit ne doit pas contient les caractères '/' ou ':'"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description Produit ", -1)),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.note_prod) = $event)),
                  placeholder: "Write your product description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, null, 512), [
                  [_vModelText, _ctx.note_prod]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantité", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. 120.00",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.qnty) = $event)),
                disabled: _ctx.variants == true
              }, null, 8, _hoisted_20), [
                [_vModelText, _ctx.qnty]
              ])
            ])
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "toggle1",
              type: "checkbox",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.variants) = $event)),
              "true-value": true,
              "false-value": false
            }, null, 512), [
              [_vModelCheckbox, _ctx.variants]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("label", {
              class: "form-check-label ms-2",
              for: "toggle1"
            }, " Ajouter Variant! ", -1))
          ]),
          (_ctx.variants)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-3",
                      key: item.id,
                      id: String(item.id)
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, "Référence *", -1)),
                          _createElementVNode("input", {
                            type: "file",
                            name: "form[]",
                            class: "form-control",
                            accept: "image/*",
                            onChange: ($event: any) => (_ctx.handleChange(item, $event)),
                            required: ""
                          }, null, 40, _hoisted_27)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label" }, "Référence *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((item.ref) = $event),
                            placeholder: "#Réf *",
                            required: "",
                            onInput: ($event: any) => (_ctx.checkRef(item.ref))
                          }, null, 40, _hoisted_30), [
                            [_vModelText, item.ref]
                          ]),
                          (_ctx.refcheck)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_31, "Référence du produit ne doit pas contient les caractères '/' ou ':'"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label" }, "Nom de la variante *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                            placeholder: "Nom de la variante *",
                            required: ""
                          }, null, 8, _hoisted_34), [
                            [_vModelText, item.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "Quantité *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((item.qnty) = $event),
                            min: "1",
                            placeholder: "1",
                            required: ""
                          }, null, 8, _hoisted_37), [
                            [
                              _vModelText,
                              item.qnty,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-danger w-100",
                          onClick: ($event: any) => (_ctx.removeItem(index)),
                          style: {"margin-bottom":"0.5rem"}
                        }, _cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "flaticon-delete me-1" }, null, -1)
                        ]), 8, _hoisted_39)
                      ])
                    ], 8, _hoisted_24))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-info mt-2 d-flex align-items-center",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.repeateAgain && _ctx.repeateAgain(...args)))
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "bi bi-plus-circle me-2" }, null, -1),
                  _createTextVNode(" Nouvelle Variante ", -1)
                ]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addProduct && _ctx.addProduct(...args))),
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[24] || (_cache[24] = [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                  ])))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.loading ? "En cours..." : "Enregistrer"), 1)
            ], 8, _hoisted_41)
          ])
        ])
      ], 4)
    ])
  ]))
}